import { Box } from '@mui/material'
import { theme } from '@/styles'

export function Separator() {
  return (
    <Box
      width="100%"
      height={2}
      bgcolor={theme.colors.$whiteSmoke}
      marginTop={2}
      marginBottom={2}
    />
  )
}
